import { createHelpers, getField, updateField } from 'vuex-map-fields'
import taskListApi from '../../../api/training/taskList'
import { WORKFLOW_ACTION_TYPE } from '../../../constant/constant'

// initial state
const state = {
  appraiserReasons: [],
  defaultNextEuid: null,
  // activeItems: [],
  historyItems: [],
  acceptItems: [],
  rejectItems: [],
  classSummariesActiveItem: {},
  classSummariesActiveItems: [],
  proposalClassActiveItems: [
    {
      applicationFormDataId: null,
      proposalClassId: null,
      workItemId: null,
      activityDefinitionId: null,
      formAttributeId: null,
      filledIPFormYears: null,
      chinTaskListTitle: null,
      portTaskListTitle: null,
      chinTaskListDesc1: null,
      portTaskListDesc1: null,
      chinTaskListDesc2: null,
      portTaskListDesc2: null,
      // staffCode: null,
      euid: null,
      staffChinName: null,
      staffPortName: null,
      staffEngName: null,
      enterCareerDate: null,
      appraiserReasonCode: null,
      appraiserReasonChinDesc: null,
      appraiserReasonPortDesc: null,
      appraiserOtherReasonStr: null,
      appraiserOrder: null,
      status,
      actionTypeId: null,
      // assignedToStaffCode: null,
      assignedToEuid: null,
      isNewApplicant: false,
      newMessage: null
    }
  ],
  proposalClassHistoryItems: [
    {
      applicationFormDataId: null,
      proposalClassId: null,
      workItemId: null,
      activityDefinitionId: null,
      formAttributeId: null,
      filledIPFormYears: null,
      chinTaskListTitle: null,
      portTaskListTitle: null,
      chinTaskListDesc1: null,
      portTaskListDesc1: null,
      chinTaskListDesc2: null,
      portTaskListDesc2: null,
      // staffCode: null,
      euid: null,
      staffChinName: null,
      staffPortName: null,
      staffEngName: null,
      enterCareerDate: null,
      appraiserReasonCode: null,
      appraiserReasonChinDesc: null,
      appraiserReasonPortDesc: null,
      appraiserOtherReasonStr: null,
      appraiserOrder: null,
      status: 0, // 0/1
      // below are new attributes for final step
      actionTypeId: null,
      // assignedToStaffCode: null,
      assignedToEuid: null,
      isNewApplicant: false
    }
  ],
  finalItems: [
    {
      applicationFormDataId: null,
      // proposalClassId: null,
      workItemId: null,
      // activityDefinitionId: null,
      // formAttributeId: null,
      // chinTaskListTitle: null,
      // portTaskListTitle: null,
      // chinTaskListDesc1: null,
      // portTaskListDesc1: null,
      // chinTaskListDesc2: null,
      // portTaskListDesc2: null,
      // staffCode: null,
      euid: null,
      staffChinName: null,
      staffPortName: null,
      // staffEngName: null,
      enterCareerDate: null,
      appraiserReasonCode: null,
      // appraiserReasonChinDesc: null,
      // appraiserReasonPortDesc: null,
      appraiserOtherReasonStr: null,
      appraiserOrder: null,
      status: 0, // 0/1
      // below are new attributes for final step
      actionTypeId: null, // 1: agree; 3: cancel; 5: End
      // assignedToStaffCode: null,
      assignedToEuid: null,
      isNewApplicant: false
    }
  ],
  attentionActiveWorkItems: [
    {
      proposalClassId: null,
      chinTaskListTitle: null,
      portTaskListTitle: null,
      chinTaskListDesc1: null,
      portTaskListDesc1: null,
      chinTaskListDesc2: null,
      portTaskListDesc2: null,
      listFollowingTrainingTaskDetail: [
        {
          workItemId: null,
          staffCode: null,
          euid: null,
          staffChinName: null,
          staffPortName: null,
          staffEngName: null,
          enterCareerDate: null,
          appraiserReasonCode: null,
          appraiserReasonChinDesc: null,
          appraiserReasonPortDesc: null,
          appraiserOtherReasonStr: null,
          appraiserOrder: null
        }
      ]
    }
  ]

}

// getters
const getters = {
  getField,

  getEnableFinalActiveItems: (state) => {
    return state.finalItems.filter(item => item.status === 1)
  },

  getDisableFinalActiveItems: (state) => {
    return state.finalItems.filter(item => item.status === 0)
  }
  // countActiveItems: (state) => {
  //   if (typeof (state.activeItems) !== 'undefined') {
  //     return state.activeItems.length
  //   } else {
  //     return 0
  //   }
  // }
}

// actions
const actions = {
  getAppraiserReasons ({ commit }) {
    taskListApi.getAppraiserReasons(appraiserReasons => {
      commit('setAppraiserReasons', appraiserReasons)
    })
  },

  getDefaultNextStaff ({ commit }) {
    taskListApi.getDefaultNextStaff(staff => {
      commit('setDefaultNextEuid', staff)
    })
  },

  // getActiveItems ({ commit }) {
  //   taskListApi.getActiveItems(activeItems => {
  //     commit('setActiveItems', activeItems)
  //   })
  // },

  getClassSummariesActiveItem ({ commit, state }, id) {
    const item = state.classSummariesActiveItems.find(activeItem => activeItem.proposalClassId === id)
    commit('setClassSummariesActiveItem', item)
  },

  getClassSummariesActiveItems ({ commit }) {
    taskListApi.getClassSummariesActiveItems(classSummariesActiveItems => {
      commit('setClassSummariesActiveItems', classSummariesActiveItems)
    })
  },

  getProposalClassActiveItems ({ commit }, proposalClassId) {
    taskListApi.getActiveItemsByProposalClassId(proposalClassActiveItems => {
      let tempItems = proposalClassActiveItems.map(classActiveItem => {
        return Object.assign(classActiveItem, { status: null,
          actionTypeId: null,
          // assignedToStaffCode: null,
          assignedToEuid: null,
          isNewApplicant: true,
          newMessage: null })
      })
      tempItems.sort(function (a, b) {
        return a.applicationFormDataId - b.applicationFormDataId
      })
      commit('setProposalClassActiveItems', tempItems)
    }, proposalClassId)
  },

  getAttentionActiveItems ({ commit }, euid) {
    taskListApi.getAttentionActiveItemsByEuid(proposalClassActiveItems => {
      commit('setAttentionActiveItems', proposalClassActiveItems)
    }, euid)
  },

  getHistoryItems ({ commit }) {
    taskListApi.getHistoryItems(historyItems => {
      commit('setHistoryItems', historyItems)
    })
  },

  getProposalClassHistoryItems ({ commit }, proposalClassId) {
    taskListApi.getHistoryItemsByProposalClassId(proposalClassHistoryItems => {
      let tempItems = proposalClassHistoryItems.map(classHistoryItem => {
        return Object.assign(classHistoryItem, { status: 1,
          actionTypeId: classHistoryItem.action,
          // assignedToStaffCode: null,
          assignedToEuid: null,
          isNewApplicant: false })
      })
      tempItems.sort(function (a, b) {
        return a.appraiserOrder - b.appraiserOrder
      })
      commit('setProposalClassHistoryItems', tempItems)
    }, proposalClassId)
  },

  updateProposalClassActiveItemStatus ({ commit }, payload) {
    commit('setProposalClassActiveItemStatus', payload)
  },

  combineActiveAndHistoryItems ({ commit }) {
    commit('prepareFinalItems')
  }

  // updateAssignedToStaffCodeValues ({ commit }, staffCode) {
  //   commit('setFinalItemsAssignedToStaffCode', staffCode)
  // }

}

// mutations
const mutations = {
  updateField,
  setAppraiserReasons (state, appraiserReasons) {
    state.appraiserReasons = appraiserReasons
  },

  setDefaultNextEuid (state, staff) {
    state.defaultNextEuid = staff.euid
  },

  setActiveItems (state, activeItems) {
    state.activeItems = activeItems
  },

  setClassSummariesActiveItem (state, activeItem) {
    state.classSummariesActiveItem = activeItem
  },

  setClassSummariesActiveItems (state, classSummariesActiveItems) {
    state.classSummariesActiveItems = classSummariesActiveItems
  },

  setProposalClassActiveItems (state, proposalClassActiveItems) {
    state.proposalClassActiveItems = proposalClassActiveItems
    state.proposalClassActiveItems.forEach(
      (element) => {
        element.isNewApplicant = true
      }
    )
  },

  setAttentionActiveItems (state, proposalClassActiveItems) {
    state.attentionActiveWorkItems = proposalClassActiveItems
  },

  setHistoryItems (state, historyItems) {
    historyItems.sort((a, b) => b.proposalClassId - a.proposalClassId)
    state.historyItems = historyItems
  },

  setProposalClassHistoryItems (state, proposalClassHistoryItems) {
    state.proposalClassHistoryItems = proposalClassHistoryItems
    state.proposalClassHistoryItems.forEach(
      (element) => {
        element.isNewApplicant = false
      }
    )
  },

  setProposalClassActiveItemStatus (state, payload) {
    state.proposalClassActiveItems[payload.index].status = payload.status
    state.proposalClassActiveItems[payload.index].actionTypeId = payload.status === 1 ? WORKFLOW_ACTION_TYPE.AGREE : WORKFLOW_ACTION_TYPE.CANCEL
  },

  prepareFinalItems (state) {
    state.finalItems = state.proposalClassHistoryItems.concat(state.proposalClassActiveItems)
    state.rejectItems = [...state.finalItems.filter(item => item.status === 0)]
    state.acceptItems = [...state.finalItems.filter(item => item.status === 1)]
  },

  setFinalItemsByList (state, list) {
    state.finalItems = list
    for (let i = 0; i < state.finalItems.length; i++) {
      state.finalItems[i].appraiserOrder = i + 1
      delete state.finalItems[i].chinTaskListTitle
      delete state.finalItems[i].portTaskListTitle
      delete state.finalItems[i].chinTaskListDesc1
      delete state.finalItems[i].portTaskListDesc1
      delete state.finalItems[i].chinTaskListDesc2
      delete state.finalItems[i].portTaskListDesc2
      delete state.finalItems[i].appraiserReasonChinDesc
      delete state.finalItems[i].appraiserReasonPortDesc
      // delete state.finalItems[i].staffCode
      delete state.finalItems[i].euid
      delete state.finalItems[i].staffEngName
      delete state.finalItems[i].staffChinName
      delete state.finalItems[i].staffPortName
      delete state.finalItems[i].enterCareerDate
      delete state.finalItems[i].proposalClassId
      delete state.finalItems[i].formAttributeId
      delete state.finalItems[i].filledIPFormYears
      delete state.finalItems[i].chinCompletedByName
      delete state.finalItems[i].portCompletedByName
    }
  },

  // setFinalItemsAssignedToEuid (state, euid) {
  //   state.finalItems.forEach(item => {
  //     item.assignedToEuid = euid
  //     // if (item.isNewApplicant && item.actionTypeId === WORKFLOW_ACTION_TYPE.AGREE && (!euid || euid === '')) {
  //     if (item.isNewApplicant && (!euid || euid === '')) {
  //       item.actionTypeId = WORKFLOW_ACTION_TYPE.END // closed
  //     }
  //   })
  // },

  setAcceptItemsAssignedToEuid (state, euid) {
    state.acceptItems.forEach(item => {
      item.assignedToEuid = euid
      if (item.isNewApplicant && !euid) {
        item.actionTypeId = WORKFLOW_ACTION_TYPE.END // closed
      } else if (item.isNewApplicant && euid) {
        item.actionTypeId = WORKFLOW_ACTION_TYPE.AGREE
      }
    })
  },

  reorderAcceptItems (state, payload) {
    if (payload.action === 'up') {
      state.acceptItems.splice((payload.index - 1), 0, state.acceptItems.splice(payload.index, 1)[0])
    } else {
      state.acceptItems.splice((payload.index + 1), 0, state.acceptItems.splice(payload.index, 1)[0])
    }
  }

}

export const { mapMultiRowFields: mapTaskListMultiRowFields } = createHelpers({
  getterType: 'trainingTaskList/getField',
  mutationType: 'trainingTaskList/updateField'
})

export const trainingTaskList = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
